export default {
  page: 1,
  pageSize: 10,
  members: [],
  pageCount: 1,
  dataReturned: false,
  activeDivision: '',
  editDivisionModalOpen: false,
};
